module.exports = __webpack_public_path__ + "img/scope.6a387a20.svg";